import { render } from "./PersonRegistrationLaunchView.vue.ts?vue&type=template&id=dba3fe58&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationLaunchView.vue?vue&type=template&id=dba3fe58&scoped=true&ts=true"
import script from "./PersonRegistrationLaunchView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationLaunchView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonRegistrationLaunchView.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationLaunchView.vue?vue&type=script&lang=ts&setup=true"

import "./PersonRegistrationLaunchView.vue.scss?vue&type=style&index=0&id=dba3fe58&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationLaunchView.vue?vue&type=style&index=0&id=dba3fe58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba3fe58"],['__file',"src/apps/core-app-onboarding/views/PersonRegistrationLaunchView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dba3fe58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dba3fe58', __exports__)) {
    api.reload('dba3fe58', __exports__)
  }
  
  module.hot.accept("./PersonRegistrationLaunchView.vue.ts?vue&type=template&id=dba3fe58&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationLaunchView.vue?vue&type=template&id=dba3fe58&scoped=true&ts=true", () => {
    api.rerender('dba3fe58', render)
  })

}


export default __exports__